import { Injectable } from '@angular/core';
import { Product } from 'gung-standard';
import { map, Observable } from 'rxjs';
import { TyloProductListByIdsConfigService } from './tylo-product-list-by-ids-config.service';

@Injectable()
export class TyloConceptProductListConfigService extends TyloProductListByIdsConfigService {
  getItems(): Observable<Product[]> {
    return super.getItems().pipe(
      map(products =>
        [...products].sort((a, b) => {
          const aSort = a.extra.pim && a.extra.pim.sequence;
          const bSort = b.extra.pim && b.extra.pim.sequence;

          if ((!bSort && aSort) || (aSort && bSort && Number(aSort) > Number(bSort))) {
            return -1;
          } else if ((!aSort && bSort) || (aSort && bSort && Number(aSort) < Number(bSort))) {
            return 1;
          } else {
            return 0;
          }
        })
      )
    );
  }
}
